import React, { useState } from 'react';
import { DesktopService } from '../../services/desktopService';

const TerminalControl = ({ targetUid, targetDeviceId, folderPath }) => {
    const [command, setCommand] = useState('');
    const [isExecuting, setIsExecuting] = useState(false);
    const [output, setOutput] = useState('');

    const handleExecute = async (e) => {
        if (e) e.preventDefault();
        if (!command.trim() || isExecuting) return;

        setIsExecuting(true);
        setOutput(prev => `> ${command}\nExecuting...`);

        try {
            // Using a unique chat session or just raw command execution?
            // Since we want raw output, we could use the existing run_terminal but without a chatId
            // so we can display it right here.

            // For now, let's just send it. We'll need a way to get the response back directly
            // DesktopService returns the taskId, we can listen to it.
            const taskId = await DesktopService.sendDesktopCommand(targetUid, targetDeviceId, {
                command: 'run_terminal',
                cmd: command,
                cwd: folderPath
            });

            // Very simple polling/waiting simulation until we fully wire the direct response back here.
            // In the Python code, the result is saved back to the task document.
            // We should use DesktopService.subscribeToTask!
            DesktopService.subscribeToTask(targetUid, targetDeviceId, taskId, (response) => {
                setOutput(prev => `> ${command}\n${response}`);
                setIsExecuting(false);
                setCommand('');
            });

        } catch (error) {
            console.error("Execution failed:", error);
            setOutput(prev => prev + `\nError: ${error.message}`);
            setIsExecuting(false);
        }
    };

    return (
        <div className="flex flex-col h-64 p-4 gap-4">
            {/* Terminal Output Log */}
            <div className="flex-1 bg-black/80 rounded-xl border border-white/10 p-4 font-mono text-[11px] text-green-400 overflow-y-auto whitespace-pre-wrap flex flex-col-reverse">
                {output || "Terminal Ready..."}
            </div>

            {/* Command Input */}
            <form onSubmit={handleExecute} className="flex gap-3">
                <div className="flex-1 relative flex items-center">
                    <span className="absolute left-4 text-green-500 font-mono text-sm">{'>'}</span>
                    <input
                        type="text"
                        value={command}
                        onChange={(e) => setCommand(e.target.value)}
                        placeholder="Enter shell command..."
                        className="w-full bg-[var(--bg-main)] border border-[var(--border-subtle)] focus:border-green-500/50 rounded-xl py-3 pl-8 pr-4 text-sm text-[var(--text-main)] font-mono outline-none transition-colors"
                    />
                </div>
                <button
                    type="submit"
                    disabled={!command.trim() || isExecuting}
                    className="px-6 bg-[var(--bg-main)] hover:bg-[#111] text-white text-sm font-semibold rounded-xl border border-[var(--border-strong)] transition-all disabled:opacity-50"
                >
                    Run
                </button>
            </form>
        </div>
    );
};

export default TerminalControl;
